import createLucideIcon from '../createLucideIcon';

const DnaOff = createLucideIcon('DnaOff', [
  [
    'path',
    {
      d: 'M15 2c-1.35 1.5-2.092 3-2.5 4.5M9 22c1.35-1.5 2.092-3 2.5-4.5',
      key: 'sxiaad',
    },
  ],
  [
    'path',
    {
      d: 'M2 15c3.333-3 6.667-3 10-3m10-3c-1.5 1.35-3 2.092-4.5 2.5',
      key: 'yn4bs1',
    },
  ],
  ['path', { d: 'm17 6-2.5-2.5', key: '5cdfhj' }],
  ['path', { d: 'm14 8-1.5-1.5', key: '1ohn8i' }],
  ['path', { d: 'm7 18 2.5 2.5', key: '16tu1a' }],
  ['path', { d: 'm3.5 14.5.5.5', key: 'hapbhd' }],
  ['path', { d: 'm20 9 .5.5', key: '1n7z02' }],
  ['path', { d: 'm6.5 12.5 1 1', key: 'cs35ky' }],
  ['path', { d: 'm16.5 10.5 1 1', key: '696xn5' }],
  ['path', { d: 'm10 16 1.5 1.5', key: '11lckj' }],
  ['line', { x1: '2', x2: '22', y1: '2', y2: '22', key: 'a6p6uj' }],
]);

export default DnaOff;
